import React from "react";
import OrderTable from "../Table";

const OrderPlaced = () => {
  return <OrderTable type="Order Placed" />;
};

export default OrderPlaced;
